import { isNotDefined } from '@sgme/fp';
import { BatchFormFieldType, updateFieldValueOnGridDataPasted } from 'components/batchForm/BatchForm.helpers';
import { BatchPasteDataContextValue } from 'components/common-form/contexts/batch/BatchPasteDataContext';
import type { SPIntl } from 'contexts/intl/intlContext';
import type { FieldMetadata } from 'models/forms/fields';
import { useEffect } from 'react';

interface UsePasteDataProps {
  metadata?: FieldMetadata;
  value: BatchFormFieldType | undefined;
  setValue: (value: BatchFormFieldType | undefined) => void;
  cellId: string;
  batchPasteDataContext: BatchPasteDataContextValue;
  formatMessage: SPIntl['formatMessage'];
}

export const usePasteData = ({
  metadata,
  value,
  setValue,
  cellId,
  batchPasteDataContext,
  formatMessage,
}: UsePasteDataProps) => {
  const { pastedGridData, setPastedGridData, setFailedPasteCells } = batchPasteDataContext;

  useEffect(() => {
    if (
      isNotDefined(pastedGridData) ||
      isNotDefined(setPastedGridData) ||
      isNotDefined(setFailedPasteCells) ||
      isNotDefined(metadata)
    ) {
      return;
    }

    updateFieldValueOnGridDataPasted(metadata, value, cellId, batchPasteDataContext, setValue, formatMessage);
  }, [
    cellId,
    metadata,
    value,
    setValue,
    formatMessage,
    batchPasteDataContext,
    pastedGridData,
    setPastedGridData,
    setFailedPasteCells,
  ]);
};
